import { render } from "./GalleryActionsDropdown.vue?vue&type=template&id=03b476d0&scoped=true"
import script from "./GalleryActionsDropdown.vue?vue&type=script&lang=js"
export * from "./GalleryActionsDropdown.vue?vue&type=script&lang=js"

import "./GalleryActionsDropdown.vue?vue&type=style&index=0&id=03b476d0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03b476d0"]])

export default __exports__